import { render, staticRenderFns } from "./CarouselList.vue?vue&type=template&id=eb04bf12&scoped=true"
import script from "./CarouselList.vue?vue&type=script&lang=js"
export * from "./CarouselList.vue?vue&type=script&lang=js"
import style0 from "./CarouselList.vue?vue&type=style&index=0&id=eb04bf12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb04bf12",
  null
  
)

export default component.exports